import axios from 'axios'
import { MessageBox, Message } from 'element-ui'
import store from '@/store'
import { getToken } from '@/utils/auth'
import { syncRequestContextCookies } from '@/utils/context-cookie'
import { t } from '@/utils/i18n-helper'

// create an axios instance
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API, // url = base url + request url
  withCredentials: true, // send cookies when cross-domain requests
  timeout: 5000 // request timeout
})

// request interceptor
service.interceptors.request.use(
  config => {
    // do something before request is sent
    syncRequestContextCookies(store.getters.language)

    if (store.getters.token) {
      // let each request carry token
      // use standard Authorization header with Bearer token
      config.headers['Authorization'] = getToken()
    }
    return config
  },
  error => {
    // do something with request error
    console.log(error) // for debug
    return Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  /**
   * If you want to get http information such as headers or status
   * Please return  response => response
  */

  /**
   * Determine the request status by custom code
   * Here is just an example
   * You can also judge the status by HTTP Status Code
   */
  response => {
    const res = response.data

    // if the custom code is not 20000, it is judged as an error.
    if (!(res.code === 200 || res.success === true)) {
      Message({
        message: res.message || res.errorMessage || 'Error',
        type: 'error',
        duration: 5 * 1000
      })

      // 50008: Illegal token; 50012: Other clients logged in; 50014: Token expired;
      if (res.code === 50008 || res.code === 50012 || res.code === 50014) {
        // to re-login
        MessageBox.confirm('You have been logged out, you can cancel to stay on this page, or log in again', 'Confirm logout', {
          confirmButtonText: 'Re-Login',
          cancelButtonText: 'Cancel',
          type: 'warning'
        }).then(() => {
          store.dispatch('user/resetToken').then(() => {
            location.reload()
          })
        })
      }
      return Promise.reject(new Error(res.message || 'Error'))
    } else {
      return res
    }
  },
  error => {
    console.log('err' + error) // for debug
    // 处理 401 错误 - 未授权，跳转到登录页
    if (error.response && error.response.status === 401) {
      Message({
        message: t('user.expired', 'Your login has expired. Please log in again.'),
        type: 'error',
        duration: 3 * 1000
      })
      // 清除 token 并跳转到登录页
      store.dispatch('user/resetToken').then(() => {
        // 使用当前路径作为 redirect 参数
        const currentPath = window.location.pathname + window.location.search
        window.location.href = `/#/login?redirect=${encodeURIComponent(currentPath)}`
      })
    } else {
      Message({
        message: error.message,
        type: 'error',
        duration: 5 * 1000
      })
    }
    return Promise.reject(error)
  }
)

export default service
